import { render, staticRenderFns } from "./RulePriceCalc.vue?vue&type=template&id=548fcf0c"
import script from "./RulePriceCalc.vue?vue&type=script&lang=js"
export * from "./RulePriceCalc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports